import { render, staticRenderFns } from "./SurveySubmissions.vue?vue&type=template&id=33e82782&scoped=true"
import script from "./SurveySubmissions.vue?vue&type=script&lang=js"
export * from "./SurveySubmissions.vue?vue&type=script&lang=js"
import style0 from "./SurveySubmissions.vue?vue&type=style&index=0&id=33e82782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e82782",
  null
  
)

export default component.exports